import { AddButton } from "@/components/AddButton";
import { NavigationContainer } from "@/components/NavigationButton";
import { Box, Dialog } from "@mui/material";
import { useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import AddIcon from "@mui/icons-material/Add";
import { FuelReportForm } from "./components/FuelReportForm";
import { useQuery } from "@apollo/client";

import { FuelTable, currentFuelControlQuery } from "./components/FuelTable";

export const FuelReport = () => {
  const params = useParams();
  const navigate = useNavigate();
  const [dialogForm, setDialogForm] = useState(false);
  const [detailId, setDetailId] = useState<undefined | number>(undefined);

  const { data } = useQuery(currentFuelControlQuery, {
    variables: { params: { id: +(params.id ?? 0) } },
  });
  const handleAddDefaultResource = (formDetailId: number) => {
    setDialogForm(true);
    setDetailId(formDetailId);
  };

  const selectedDetail = data?.report?.fuelControlDetails?.find(
    (detail) => detail.id === detailId
  );
  const goBack = () => navigate(`/formulario-reporte/${params.id}/suministros`);
  const goNext = () => {
    navigate(`/formulario-reporte/${params.id}/transporte`);
  };
  return (
    <Box sx={{ marginBottom: 12 }}>
      <FuelTable onEdit={(detail) => handleAddDefaultResource(detail.id)} />

      <AddButton
        variant="contained"
        onClick={() => {
          setDialogForm(true);
          setDetailId(undefined);
        }}
      >
        <AddIcon />
        AGREGAR OTRO
      </AddButton>
      <Dialog
        open={dialogForm}
        onClose={() => setDialogForm(false)}
        fullWidth
        PaperProps={{ sx: { maxWidth: 400 } }}
      >
        <FuelReportForm
          close={() => setDialogForm(false)}
          detail={{
            ...selectedDetail,
            performance: selectedDetail?.performance ?? undefined,
            hours: selectedDetail?.hours ?? undefined,
            dieselLastHourometer:
              selectedDetail?.dieselLastHourometer ?? undefined,
            initialHourometer: selectedDetail?.initialHourometer ?? undefined,
            finalHourometer: selectedDetail?.finalHourometer ?? undefined,
            resourceName: selectedDetail?.resourceName ?? "",
            id: selectedDetail?.id ?? undefined,
            diesel: selectedDetail?.diesel ?? undefined,
            dieselHourometer: selectedDetail?.dieselHourometer ?? undefined,
            resourceDetail: selectedDetail?.resourceDetail ?? "",
            type: selectedDetail?.type ?? "GENERIC",
          }}
        />
      </Dialog>

      <NavigationContainer handleNext={goNext} handlePrev={goBack} />
    </Box>
  );
};
